import isInLengthValidatorUtil from '../../../../redux/utils/validate/validators/is-in-length'

function descriptionPostValidator (value) {
  return isInLengthValidatorUtil({
    key: 'description',
    name: 'Description',
    max: 4096,
    min: 1,
    value
  })
}

export {
  descriptionPostValidator
}
